import { API_NAMES, initApi } from "@usas/ui-web/utils/HttpApiHelper";

const putNewClubRegistrationCartItemData = (personId, orgUnitId, orgUnitCode, overrideFee, clubRegObj, state, setState) => {
  if (personId > 0 || personId.length > 0) {
    const api = initApi(API_NAMES.CLUB, state, setState);
    const personIdForUrl = encodeURIComponent(personId);
    const orgUnitIdForUrl = encodeURIComponent(orgUnitId);
    const url = `/UsasClub/cartitem/${personIdForUrl}/orgunit/${orgUnitIdForUrl}/${orgUnitCode}/overrideFee/${overrideFee}`;

    return api?.executeArray ? api.executeArray(url, 'PUT', clubRegObj) : null;
  }
};

const NewClubRegistrationPaymentData = {
  putNewClubRegistrationCartItemData
};

export default NewClubRegistrationPaymentData;